
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { Box } from 'reactjs-admin-lte'
import { Image, FormControl, Grid, Row, Col, Button,ButtonGroup,Label } from 'react-bootstrap'
// import QRstore from './QRstore'
import QRstore from '../../../stores/QRstore'
import SearchStore from 'stores/SearchStore'
import querystring from 'querystring'
import moment from 'moment'
import { QRCode } from 'react-qr-svg'
import FontAwesome from 'react-fontawesome'
import Select from 'react-select'
import JobControlBoardTable from 'view/workdoc/jobcontrol/JobControlBoardTable'
import * as _ from 'lodash';
import './Tracker.css'

const CLOSE_TIMER  = 15
const REASON_LIST = [
  {label:'รถรออะไหล่',value:'01'},
  {label:'งานก่อนหน้าไม่สมบูรณ์',value:'02'},
  {label:'ขาด/ลา',value:'03'}
  ]
  
class WorkTracker extends Component {

  constructor(...args){
    super(...args)
    this.closeTimer = CLOSE_TIMER
    if(this.props.closeTimer!==undefined && this.props.closeTimer*1>=5){
      this.closeTimer = this.props.closeTimer*1
    }
    console.log('closeTimer',this.closeTimer);
    this.state = Object.assign({reasonList:REASON_LIST},this.initState())
    this.focusInput=''
    
  }

  initState(){
    return {isLoadingAPI:false,activeTask:{},give_reason:'',entryText:'',employeeData:null,workData:null,jobList:[],elapsed: {
      hours: 0,
      minutes: 0,
      seconds: 0
    },closeElapsed:{seconds:0},startTime:null,startCloseTime:null,job_scan_status:'',reasonCode:'',scanState:1,errMsg:'',infoMsg:''}
  }

  componentDidMount(){
    let that = this
    QRstore.loadOption(function(result){
      console.log('resultReason',result)
      if(result.data.reason_list!==undefined)
        that.setState({reasonList:result.data.reason_list})
    })
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  startTimer() {
    clearInterval(this.timer)
    this.timer = setInterval(this.tick.bind(this), 1000)
  }

  startCloseTimer() {
    clearInterval(this.closeTimerInst)
    this.closeTimerInst = setInterval(this.closeTick.bind(this), 1000)
  }

  closeTick(){
    let {startCloseTime} = this.state

    let seconds = 0;
    if(startCloseTime){
      const thisMoment = moment()
      seconds = this.closeTimer - thisMoment.diff(startCloseTime, 'seconds')*1
    }
    if(seconds<=0){
      this.setState(this.initState())
      clearInterval(this.closeTimerInst)
      clearInterval(this.timer)
    }else{
      this.setState((prevState) =>
        ({
          closeElapsed: {
            seconds: seconds
          }
        })
      )
    }
  }

  tick() {
    const thisMoment = moment()
    this.setState((prevState) =>
      ({
        elapsed: {
          hours: thisMoment.diff(prevState.startTime, 'hours'),
          minutes: thisMoment.diff(prevState.startTime, 'minutes'),
          seconds: thisMoment.diff(prevState.startTime, 'seconds')
        }
      })
    )
  }

  handleEmployeeURL(params) {
    const ex_emp_id = params['e_id']
    const bf_org_id = params['o_id']
    this.setState({isLoadingAPI:true})
    QRstore.loadEmployee(ex_emp_id, bf_org_id,
      (result) => {
        console.log(result)
        //const url = 'http://localhost:3000/?p=tcp&w_id=17221edb-f&o_id=korat'
        this.setState({
          profileImgURL: QRstore.getProfileImgURL(ex_emp_id, bf_org_id),
          employeeData: result.data,          
          errMsg: '',
          isLoadingAPI:false
        }, () => {

        })        
      },
      (err) => { this.setState({isLoadingAPI:false}) })
  }

  handlePublicWorkUrl(params) {

    const ex_work_id = params['w_id']
    const bf_org_id = params['o_id']
    const ex_emp_id = this.state.employeeData.ext_employee_id
    const emp_id = this.state.employeeData.employee_id
    const department = this.state.employeeData.department
    const {job_scan_status,jobList} = this.state
    /* 
    // in case check emp_id on front-end
    // const ex_emp_id = params['e_id']
    if (this.state.employeeData.ext_employee_id !== ex_emp_id) {
      // err msg: incorrect emp id
      return
    } */

    this.setState({isLoadingAPI:true})
    QRstore.loadCar(ex_work_id, bf_org_id, emp_id,department,job_scan_status,
      (result) => {
        //console.log(result)
        this.handleWorkData(result)
      },
      (err) => {
        // incorrect emp_id
        this.setState({isLoadingAPI:false})
      })
  }


  handleWorkData(result){
    const department = this.state.employeeData.department
    let {jobList} = this.state
    if(result.data.scan_type==='START_READY'){
      //this.startTimer()
      this.startCloseTimer()
      this.setState({job_scan_status:'START',startCloseTime:moment(),closeElapsed:{seconds:this.closeTimer},scanState:4})          
    }else if(result.data.scan_type==='START'){

      this.setState({job_scan_status:'CONFIRM_JOB'})   
    }else if(result.data.scan_type==='END'){
      this.startCloseTimer()
      this.setState({job_scan_status:'END',startCloseTime:moment(),closeElapsed:{seconds:this.closeTimer},scanState:4})        
    }else if(result.data.scan_type=='LEADER_SCAN_JOB'){
      let dup = false
      jobList.map((item,index)=>{
        if(item.work_no===result.data.work_no){
          dup = true
        }
        return item
      })
      let infoMsg = ''
      if(!dup){
        jobList.push(result.data)
        
      }else{
        infoMsg = 'จ็อบซ้ำ แสกนใบจ็อบอื่น'
      }
      this.setState({job_scan_status:result.data.scan_type,jobList:jobList,infoMsg:infoMsg})
    }else if(result.data.scan_type=='LEADER_CANCEL_SENT'){
      this.startCloseTimer()
      this.setState({job_scan_status:result.data.scan_type,startCloseTime:moment(),closeElapsed:{seconds:this.closeTimer},scanState:4})
    }else if(result.data.scan_type=='LEADER_END_SENT'){
      this.startCloseTimer()
      this.setState({job_scan_status:result.data.scan_type,startCloseTime:moment(),closeElapsed:{seconds:this.closeTimer},scanState:4})  
    }else if(result.data.scan_type=='START_OPTION'){
      
      this.setState({job_scan_status:result.data.scan_type,startOptionList:result.data.start_option})
    }else{
      this.setState({job_scan_status:result.data.scan_type})
    }
    // check if task state is either NONE, STARTED,...
    // result.data.task.tasklist[0].startDate === '' --> state.currentTaskState === this.TASK_STATES.NONE        
    let activeTask = _.find(result.data.work_state,{department:department})
    if(result.data.last_task!==undefined && result.data.last_task!==''){
      let lastTask = _.find(result.data.work_state,{value:result.data.last_task})
      if(lastTask!==undefined &&  lastTask!==null){
        activeTask = lastTask
      }  
    }
    this.setState({isLoadingAPI:false,workData:result.data,activeTask:activeTask})
    this.handleJobStatus(result.data,activeTask)
  }

  handleJobStatus(data,activeTask){
    //work_date

    //let workData = _.pick(data, ['work_no', 'car_registration_no','customer_name','work_date','work_duration','appointment_date','damage_level']);
    let readonly = data.scan_type!=='START_OPTION'
    if(data.last_scan_type!==undefined && data.last_scan_type==='PAUSE'){
      readonly = true
    }
    let workData = Object.assign(data,{car_detail:data.car_detail_text})
    if(this.refs.jcbTable!==undefined)
      this.refs.jcbTable.getWrappedInstance().loadData([workData],data.work_state,activeTask,readonly)
  }

  saveTimeRecordUrl(action,value='',savedFunc){
    let {employeeData,workData} = this.state
    this.setState({infoMsg:'กำลังบันทึกข้อมูล...'})
    QRstore.saveTimeRecord(action,workData.work_no, employeeData.employee_id,employeeData.department,value,
      (result) => {
        console.log(result)
        if(savedFunc!==undefined){
          savedFunc()
        }else{
          this.startCloseTimer()
          // check if task state is either NONE, STARTED,...
          // result.data.task.tasklist[0].startDate === '' --> state.currentTaskState === this.TASK_STATES.NONE
          this.setState({job_scan_status:action.toUpperCase(),startCloseTime:moment(),closeElapsed:{seconds:this.closeTimer},infoMsg:''})
        }
      },
      (err) => {
        // incorrect emp_id
        this.setState({infoMsg:'พบปัญหาบันทึกข้อมูล...'})
      })
  }

  onActiveTaskChange(activeTask){
    this.setState({activeTask:activeTask})
  }

  onEntryChange(e){
    //this.setState({ employeeUrl: e.target.value })
    this.setState({entryText:e.target.value})
  }

  async onEnteyKeyPress(e){
    if (e.key !== 'Enter' || this.state.employeeUrl === '') return

    //console.log('keyEnter',e.target.value)
    
    const url = (e.target.value+"").toLowerCase()      
    const qStr = url.slice(url.indexOf('?') + 1)
    const params = querystring.parse(qStr)    
    const page = params['p']
    const { profileImgURL,employeeData,workData,startCloseTime,job_scan_status } = this.state
    let that = this
    this.setState({entryText:''})

    if(startCloseTime){
      this.setState({infoMsg:'ไม่สามารถแสกน กรุณารอสักครู่...'})
      return
    }

    if (page === 'tr') {
      //Task Run With Employee
      // this.setState({ errMsg: 'สแกนบัตรพนักงานก่อน' })      
      this.setState(Object.assign(this.initState(),{errMsg:'',scanState:2}))
      this.handleEmployeeURL(params)      
    } else if (page === 'tcp') {
      //Task Job Scan
      if(employeeData===null){
        this.setState({ errMsg: 'ยังไม่ได้สแกนบัตรพนักงาน' })
         
      }else{
        
        this.setState({scanState:3,infoMsg:''})
        this.handlePublicWorkUrl(params)        
        
      }
    } else if (page === 'wp') {
      //Work Pause
      //this.setState({ errMsg: 'สแกนบัตรพนักงานก่อน' })
      if(employeeData==null){
        this.setState({ errMsg: 'ยังไม่ได้สแกนบัตรพนักงาน' })
      }else if(workData==null){
        this.setState({ errMsg: 'ยังไม่ได้สแกนใบสั่งซ่อม' })
      }else{
        let that = this      
        that.setState({job_scan_status:"GIVE_REASON",infoMsg:''})  
        // this.saveTimeRecordUrl('pause',function(){
        //   //save
        //   console.log('give reason')
          
        // })
      }
    } else if (page === 'wst') {
      //Work Stop
      //this.setState({ errMsg: 'สแกนบัตรพนักงานก่อน' })
      if(employeeData==null){
        this.setState({ errMsg: 'ยังไม่ได้สแกนบัตรพนักงาน' })
      }else if(workData==null){
        this.setState({ errMsg: 'ยังไม่ได้สแกนใบสั่งซ่อม' })
      }else{
        this.setState({scanState:4})
        this.saveTimeRecordUrl('end',params['v'])        
      }
    } else if (page === 'rs') {
      //Reason Code
      if(employeeData==null){
        this.setState({ errMsg: 'ยังไม่ได้สแกนบัตรพนักงาน' })
      }else if(workData==null){
        this.setState({ errMsg: 'ยังไม่ได้สแกนใบสั่งซ่อม' })
      }else{     
        this.setState({infoMsg:'กำลังบันทึกข้อมูล....',scanState:4,reasonCode:params['v']})   
        this.savePauseReason(params['v'],this.getReasonMsg(params['v']),params['v2'])        
      }
    } else if (page === 'lo') {
      //Leader Scan Job
      if(employeeData==null){
        this.setState({ errMsg: 'ยังไม่ได้สแกนบัตรพนักงาน' })
      }else{   
        //Scan work
        this.setState({job_scan_status:'LEADER_SCAN_JOB',infoMsg:'เริ่มแสกนใบจ็อบ ทีละใบจนครบ'})
      }
    } else if (page === 'lc') {
      //Leader Cancel Job
      if(employeeData==null){
        this.setState({ errMsg: 'ยังไม่ได้สแกนบัตรพนักงาน' })
      }else{   
        //Scan work
        this.setState({job_scan_status:'LEADER_CANCEL_JOB',infoMsg:'เริ่มแสกนใบจ็อบที่จะยกเลิก'})
      }  
    } else if (page === 'le') {
      //Leader End Job
      if(employeeData==null){
        this.setState({ errMsg: 'ยังไม่ได้สแกนบัตรพนักงาน' })
      }else{   
        //Scan work
        this.setState({job_scan_status:'LEADER_END_JOB',infoMsg:'เริ่มแสกนใบจ็อบที่จะปิดงาน'})
      }        
    } else if (page === 'pj') {
      //Pause JOB
      if(employeeData==null){
        this.setState({ errMsg: 'ยังไม่ได้สแกนบัตรพนักงาน' })
      }else{   
        //Scan work
        this.setState({infoMsg:'กำลังบันทึกข้อมูล....',scanState:4})
        this.savePullJob()
      }  
    } else if (page === 'so') {
      //Start Option
      if(employeeData==null){
        this.setState({ errMsg: 'ยังไม่ได้สแกนบัตรพนักงาน' })
      }else{   
        //Scan work
        this.setState({infoMsg:'กำลังบันทึกข้อมูล....',scanState:4})
        this.saveTimeRecordUrl('start',params['v']) 
      } 
    }else{
      let result = await this.handleSearchcode(url)
      if(!result){
        this.setState({infoMsg:'แสกนรหัสไม่ถูกต้อง...'})   
        setTimeout(function(){ 
          that.setState({infoMsg:''})   
        }, 3000);
      }
    }
  }

  async handleSearchcode(inputCode){
    let {employeeData} = this.state
    if(employeeData==null){
      return await this.handleSearchEmployee(inputCode)
    }else {      
      
      const {employee_id,department} = employeeData
      const {job_scan_status} = this.state    

      this.setState({isLoadingAPI:true})
      const result = await SearchStore.searchPublicWork(inputCode, employee_id,department,job_scan_status)
      this.setState({isLoadingAPI:false})
      if(result.status=='OK'){
        this.setState({errMsg:'',scanState:3})
        this.handleWorkData(result)    
        return true
      }else{
        return await this.handleSearchEmployee(inputCode)
      }
    }
    return false
  }

  async handleSearchEmployee(inputCode){
    this.setState({isLoadingAPI:true})     
    let result = await SearchStore.searchEmployee(inputCode)     
    this.setState({isLoadingAPI:false}) 
    if(result.status==='OK'){        
        let {bf_org_id,ext_employee_id} = result.data
        this.setState(Object.assign(this.initState(),{errMsg:'',scanState:2},
        {
          profileImgURL: QRstore.getProfileImgURL(ext_employee_id, bf_org_id),
          employeeData: result.data,          
          errMsg: '',
          isLoadingAPI:false
        }))        
        return true;
    }
    return false;
  }

  
  savePauseReason(reasonCode,reason,taskState=''){
    
    let {timeId,employeeData,workData} = this.state    
    
    QRstore.savePauseReason(workData.work_no, employeeData.employee_id,employeeData.department,reasonCode,reason,taskState,
      (result) => {
        console.log(result)
        
        this.startCloseTimer()
          // check if task state is either NONE, STARTED,...
          // result.data.task.tasklist[0].startDate === '' --> state.currentTaskState === this.TASK_STATES.NONE
        this.setState({job_scan_status:'PAUSE',startCloseTime:moment(),closeElapsed:{seconds:this.closeTimer},infoMsg:''})
      },
      (err) => {
        // incorrect emp_id
      })
  }

  savePullJob(){
    
    let {timeId,employeeData,workData,jobList} = this.state    
    
    QRstore.savePullJob(employeeData.employee_id,employeeData.department,jobList,
      (result) => {
        console.log(result)
        
        this.startCloseTimer()
          // check if task state is either NONE, STARTED,...
          // result.data.task.tasklist[0].startDate === '' --> state.currentTaskState === this.TASK_STATES.NONE
        this.setState({job_scan_status:'PULL_JOB_DONE',startCloseTime:moment(),closeElapsed:{seconds:this.closeTimer},infoMsg:''})
      },
      (err) => {
        // incorrect emp_id
      })
  }

  

  async onQRButtonClick(text){
    //this.setState({entryText:text})
    let e = {target:{value:text},key:'Enter'}
    this.onEnteyKeyPress(e)
  }


  onWorkTrackerAreaClick(){
    console.log('onAreaClick');
    ReactDOM.findDOMNode(this.focusInput).focus();
  }

  onLederJobClick(){

  }

  getReasonMsg(reasonCode){
    let {reasonList}  = this.state
    let msg = ''
    reasonList.map((item,index)=>{
      if(item.value===reasonCode){
        msg = item.label
      }
      return item
    })
    return msg
  }

  getCurrentTime(){
    return moment().format('HH:mm')
  }

  renderQRReason(){
    let {reasonList,employeeData,activeTask} = this.state

    reasonList = reasonList.reduce((rresult,item)=>{
      if(item.department!==undefined){
        if(employeeData.department==item.department){
          rresult.push(item)  
        }
      }else{
        rresult.push(item)
      }
      return rresult
    },[])
    let mdSize = (reasonList.length==4)?3:4
    return (<Row>
      <h1>เลือกเหตุผลหยุดงาน</h1>
      <div style={{width:'100%'}}>
        <Row>
        {reasonList.map((item,index)=>(
              <Col key={index} md={mdSize}>
                <Button onClick={this.onQRButtonClick.bind(this,QRstore.getReasonUrl(item.value,activeTask.value))}>
                  <QRCode          
                      fgColor="#000000"
                      level="Q"
                      style={{
                        width: 180,
                        borderStyle: 'solid',
                        borderColor: 'yellow'
                      }}
                      value={QRstore.getReasonUrl(item.value,activeTask.value)}
                    />
                </Button>
                <h3>    {item.label}        </h3>
                {this.props.debug==='1'?QRstore.getReasonUrl(item.value,activeTask.value):''}
              </Col>
            ))
          }
        </Row>                                  
      </div>
</Row>)
  }

  renderStartOption(){
    let {startOptionList,activeTask,workData} = this.state
    let mdSize = (startOptionList.length==1)?12:(startOptionList.length==2)?6:4

    let itemValue = '',itemLabel=''
    if(workData.last_scan_type!==undefined && workData.last_scan_type==='PAUSE'){
      //Pause depoend on system
      
    }else{
      itemValue = (startOptionList.length===1 && activeTask.value!==undefined)?activeTask.value:''
      itemLabel = (startOptionList.length===1 && activeTask.label!==undefined)?activeTask.label:''  
    }
    return (<Row>
              <h1>เลือกขั้นตอนที่เริ่มงาน</h1>
              <div style={{width:'100%'}}>
                <Row>
                {startOptionList.map((item,index)=>(
                      <Col key={index} md={mdSize}>
                        <Button onClick={this.onQRButtonClick.bind(this,QRstore.getStartOptionUrl(itemValue!==''?itemValue:item.value))}>
                          <QRCode          
                              fgColor="#000000"
                              level="Q"
                              style={{
                                width: 180,
                                borderStyle: 'solid',
                                borderColor: 'yellow'
                              }}
                              value={QRstore.getStartOptionUrl(itemValue!==''?itemValue:item.value)}
                            />
                        </Button>
                        <h3>    {itemLabel!==''?itemLabel:item.label}        </h3>
                        {this.props.debug==='1'?QRstore.getStartOptionUrl(itemValue!==''?itemValue:item.value):''}
                      </Col>
                    ))
                  }
                </Row>                                  
              </div>
        </Row>)
  }

  renderScanStatus(){
    let {job_scan_status,give_reason,reasonCode,jobList} = this.state
    if(job_scan_status=='CONFIRM_JOB'){
      return this.renderScanToPause()
    }else if(job_scan_status=='PAUSE'){

      return (<Row>
          <h1>ได้หยุดงานไว้ชั่วคราว เนื่องจาก{this.getReasonMsg(reasonCode)} เมื่อเวลา {this.getCurrentTime()}</h1>
          <h1>กรุณามาแสกนงานใหม่ เมื่อเริ่มงานอีกครั้ง</h1>
      </Row>)
    }else if(job_scan_status=='END'){
      return (<Row>
          <h1>บันทึกงานสิ้นสุดแล้วเวลา {this.getCurrentTime()} เรียบร้อย</h1>
      </Row>)
    }else if(job_scan_status=='START'){
      return (<Row>
             <h1>บันทึกเริ่มงานเวลา {this.getCurrentTime()} เรียบร้อย</h1>
        </Row>) 
    }else if(job_scan_status=='LEADER_CANCEL_SENT'){
      return (<Row>
             <h1>ส่งยกเลิกจ็อบเวลา {this.getCurrentTime()} เรียบร้อย</h1>
        </Row>) 
    }else if(job_scan_status=='LEADER_END_SENT'){
      return (<Row>
             <h1>ส่งจบงานจ็อบเวลา {this.getCurrentTime()} เรียบร้อย</h1>
        </Row>)        
    }else if(job_scan_status=='START_OPTION'){
      
      return this.renderStartOption()    
    }else if(job_scan_status=='GIVE_REASON'){
      
      return this.renderQRReason()
    }else {
      return ('')
    }
  }
  
  renderLeaderOption(){
    const { profileImgURL, employeeData, errMsg ,scanState,job_scan_status } = this.state
    if(employeeData.is_leader && scanState===2 && job_scan_status!=='LEADER_SCAN_JOB' && job_scan_status!=='LEADER_CANCEL_JOB'&& job_scan_status!=='LEADER_END_JOB'){
      return (<Row>
        <Col md={12}><h1>ถ้าต้องการแสกนจ็อบให้ตัวเอง ให้แสกนใบจ็อบได้เลย</h1></Col>
        <Col md={4}>
          <h1>แสกนเอาจ็อบให้ทีม</h1>
          <div>
            <Button onClick={this.onQRButtonClick.bind(this,QRstore.getLeaderOptionUrl())}>
              <QRCode          
                  fgColor="#000000"
                  level="Q"
                  style={{
                    width: 180,
                    borderStyle: 'solid',
                    borderColor: 'yellow'
                  }}
                  value={QRstore.getLeaderOptionUrl()}
                />                
            </Button>            
          </div>
          <div>
          {this.props.debug==='1'?QRstore.getLeaderOptionUrl():''}
          </div>
      </Col> 
      <Col md={4}>
        <h1>แสกนยกเลิกจ็อบในทีม</h1>
          <div>
            <Button onClick={this.onQRButtonClick.bind(this,QRstore.getLeaderCancelJobUrl())}>
              <QRCode          
                  fgColor="#000000"
                  level="Q"
                  style={{
                    width: 180,
                    borderStyle: 'solid',
                    borderColor: 'yellow'
                  }}
                  value={QRstore.getLeaderCancelJobUrl()}
                />                
            </Button>            
          </div>
          <div>
          {this.props.debug==='1'?QRstore.getLeaderCancelJobUrl():''}
          </div>
      </Col>
      <Col md={4}>
        <h1>แสกนจบงานจ็อบในทีม</h1>
          <div>
            <Button onClick={this.onQRButtonClick.bind(this,QRstore.getLeaderEndJobUrl())}>
              <QRCode          
                  fgColor="#000000"
                  level="Q"
                  style={{
                    width: 180,
                    borderStyle: 'solid',
                    borderColor: 'yellow'
                  }}
                  value={QRstore.getLeaderEndJobUrl()}
                />                
            </Button>            
          </div>
          <div>
          {this.props.debug==='1'?QRstore.getLeaderEndJobUrl():''}
          </div>
      </Col>
      </Row>
      )
    }else{
      return ('')
    }
  }

  renderProfile() {
    const { profileImgURL, employeeData, errMsg } = this.state
    if (employeeData === null)
      return ('')

    const lis = [
      `${employeeData.first_name} ${employeeData.last_name} (${employeeData.nick_name}) ตำแหน่ง${employeeData.position} แผนก${employeeData.department} รหัส ${employeeData.employee_id} `,
       
    ].map((ele, index) =>
      <li key={index}><h1>{ele}</h1></li>
    )
    return (
      <div>
        <Image src={profileImgURL} circle />
        <ul>
          {lis}
        </ul>    
        {this.renderLeaderOption()}    
      </div>
    )
  }

  renderCounter(hours, minutes, seconds) {
    const theHours = hours
    const theMinutes = minutes - hours * 60
    const theSeconds = seconds - minutes * 60
    const displayHours = theHours > 0 ? `${theHours} ชั่วโมง` : ''
    const displayMinutes = theMinutes > 0 ? `${theMinutes} นาที` : ''
    const displaySeconds = `${theSeconds} วินาที`
    const time = `${displayHours} ${displayMinutes} ${displaySeconds}`
    // const displayTime = isNaN(time) ? '' : time
    // console.log(displayTime)
    return `เริ่มงานไปแล้ว ${displayHours} ${displayMinutes} ${displaySeconds}`
  }

  renderWorkDetail(){
    const {workData,jobList,job_scan_status,errMsg} = this.state

    if(jobList.length>0){
      if(job_scan_status=='PULL_JOB_DONE'){
        return (
          <Row>
            <h1>ดึงจ็อบทั้งหมด {jobList.length} ใบเมื่อเวลา {this.getCurrentTime()} เรียบร้อย </h1>
          </Row>
        )
      }
      return (
          <Row>
              <h1>รายการจ็อบทั้งหมด {jobList.length} ใบ</h1>
                {jobList.map((item,index)=>(
                  <Label key={index} bsStyle='warning' style={{fontSize:'22px',marginLeft:'15px',whiteSpace:'normal',lineHeight:'2.3'}}>
                {index+1}.){item.work_no}/{item.car_registration_no}
                  </Label>
                ))}
              <h1>เมื่อแสกนใบจ็อบครบทุกใบ ให้ทำการแสกนดึงจ็อบด้านล่าง</h1>
              <Button onClick={this.onQRButtonClick.bind(this,QRstore.getPullJobUrl())}>
               <QRCode          
                  fgColor="#000000"
                  level="Q"
                  style={{
                    width: 208,
                    borderStyle: 'solid',
                    borderColor: 'yellow'
                  }}
                  value={QRstore.getPullJobUrl()}
                /> 
                </Button>
                <br/>
                {this.props.debug==='1'?QRstore.getPullJobUrl():''}
          </Row>)
      
    }

    if(workData===null ){
      return ('')
    }        

    return (
      <div>              
        {this.renderJobStatus()}
        {this.renderScanStatus()}
      </div>
    )
  }

  renderJobDetail(workData){
    return (
      <div>
        <h2>ทะเบียน : <b>{workData.car_registration_no}</b> ยี่ห้อ : {workData.car_detail.brand} / {workData.car_detail.model} / {workData.car_detail.series}</h2>
        <h2>ใบงานเลขที่ {workData.work_no}</h2>  
      </div>
    )
  }

  renderScanToPause() {
    let {activeTask} = this.state
    return (
      <div>    
        <Row>
          <Col md={6}>    
            <Button onClick={this.onQRButtonClick.bind(this,QRstore.getPauseUrl(activeTask.value))}>
            <QRCode          
              fgColor="#000000"
              level="Q"
              style={{
                width: 208,
                borderStyle: 'solid',
                borderColor: 'yellow'
              }}
              value={QRstore.getPauseUrl(activeTask.value)}
            />
            </Button>
            <br/>
            <h1>
            <Label bsStyle='warning'>หยุดงานชั่วคราว</Label>
            </h1>
            {this.props.debug==='1'?QRstore.getPauseUrl(activeTask.value):''}
            </Col>
            <Col md={6}>
            <Button onClick={this.onQRButtonClick.bind(this,QRstore.getStopUrl(activeTask.value))}>
              <QRCode          
                fgColor="#000000"
                level="Q"
                style={{
                  width: 208,
                  borderStyle: 'solid',
                  borderColor: 'green'
                }}
                value={QRstore.getStopUrl(activeTask.value)}
              />
              </Button>
              <br/>
              <h1>
              <Label bsStyle='success'>เสร็จงานเรียบร้อย</Label>
              </h1>
              {this.props.debug==='1'?QRstore.getStopUrl(activeTask.value):''}
            </Col>
       </Row>
      </div>
    )
  }

  renderCloseStartTime(){
    let {closeElapsed} = this.state
    if(closeElapsed.seconds>0){
      return (<Row>
                <h1><Label bsStyle='warning'>หน้าต่างจะปิดเองในอีก {closeElapsed['seconds']}</Label></h1>
                <Button bsSize='lg' onClick={()=>{this.setState({startCloseTime:null})}}><FontAwesome name='circle-o-notch'/> หรือคลิ๊กเพื่อปิดเอง</Button>
              </Row>)
    }else{
      return ('')
    }
  }

  renderStartTime(){
    let {workData,startTime,elapsed} = this.state
    const startCheck = (
      <FontAwesome
        // className="super-crazy-colors"
        name="check"
        // size="1x"
        // spin
        style={{
          textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)',
          color: 'green'
        }}
      />
    )

    const displayStartDateTime =
      `เริ่มงาน ${moment(startTime).format('DD/MM/YYYY')}
          เวลา ${moment(startTime).format("HH:mm")}`
    const counter = this.renderCounter(elapsed['hours'], elapsed['minutes'], elapsed['seconds'])
    const displayCounter = (
      <div>{startCheck}{counter}</div>
    )

    
    return (
      <div>
        <h2>{displayStartDateTime}</h2>
        <h2>{displayCounter}</h2>
      </div>
    )
  }

  

  renderEntryInput() {
    // if (this.state.profileImgURL !== '') return null
    let {scanState,isLoadingAPI} = this.state
    let placeholder = (scanState===1)?'แสกนบัตรพนักงาน...':(scanState===2)?'แสกนใบจ็อบ...':'จบสถานะงาน'

    return (
      <div style={{width: '600px',display:'inline-block',textAlign:'center'}}>    
        <Row>   
          <Col md={12}> 
            <ButtonGroup bsSize='large' justified >
              
              <Button bsStyle={(scanState===1)?'warning':'success'}>1. บัตรพนักงาน</Button>
              <Button bsStyle={(scanState===2)?'warning':(scanState>2)?'success':'danger'}>2. ใบจ็อบ</Button>
              <Button bsStyle={(scanState===3)?'warning':(scanState>=3)?'success':'danger'}>3. สถานะงาน</Button>
            </ButtonGroup>
          </Col>
        </Row>
        <br/>
          <FormControl
            ref={(input) => { this.focusInput = input; }}
            autoFocus
            type='text'
            placeholder={placeholder}
            value={this.state.entryText}
            onChange={this.onEntryChange.bind(this)}
            onKeyPress={this.onEnteyKeyPress.bind(this)}
          />
          {isLoadingAPI?(<div><FontAwesome name='spinner'/> กำลังประมวลผล...</div>):''}
      </div>
    )
  }

  renderErrorMsg(){
    
    if(this.state.errMsg !== '')
      return (<h1><Label bsStyle='danger'>{this.state.errMsg}</Label></h1>)
    else
      return ('')
  }

  renderInfoMsg(){
    
    if(this.state.infoMsg !== '')
      return (<h1>{this.state.infoMsg}</h1>)
    else
      return ('')
  }

  renderJobStatus(){
    return (
      <Col md={12}>
        <JobControlBoardTable ref='jcbTable' showSearch={false} onActiveTaskChange={this.onActiveTaskChange.bind(this)}/>
      </Col>      
    )
  }

  render() {
    const mainStyle = {
      width: '100%',
      margin: '15px auto 10px',
      textAlign: 'center'
    }

    return (
      <div className='work-tracker' 
      style={{height:window.innerHeight+'px'}}
      onClick={this.onWorkTrackerAreaClick.bind(this)}>        

            <Row>
              <div className='col-md-12' style={mainStyle}>                
                {this.renderEntryInput()}
                {this.renderProfile()}
                {this.renderWorkDetail()}
                {this.renderErrorMsg()}
                {this.renderInfoMsg()}
                {this.renderCloseStartTime()}                
              </div>
            </Row>

      </div>
    )
  }
}

WorkTracker.defaultProps = {
  debug : 0,
  startTaskAuto : true,
  closeTimer:CLOSE_TIMER
}

export default WorkTracker;





// WEBPACK FOOTER //
// ./src/view/workdoc/qrtracker/WorkTracker.js